import { DatasetApiService } from '../services/dataset-api.service'
import { Store } from '@ngrx/store'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { ToasterService } from '../services/toaster.service'
import { RouterUtilsService } from '../services/router-utils.service'
import { catchError, map, Observable, of, tap } from 'rxjs'
import { caseActions } from '../../state/case/case.actions'
import { mapApiResponseToViewerState } from '../../state/viewer/viewer-state-utils'
import { viewerActions } from '../../state/viewer/viewer.actions'

export interface CaseResolverDependencies {
    datasetApi: DatasetApiService
    store: Store
    route: ActivatedRouteSnapshot
    router: Router
    toaster: ToasterService
    routerUtils: RouterUtilsService
}

export const resolveCase = (
    shared: boolean,
    dependencies: CaseResolverDependencies
): Observable<boolean> => {
    const queryParams = dependencies.routerUtils.getViewerQueryParams(dependencies.route)
    const caseId = dependencies.route.paramMap.get('caseId')
    if (caseId === null) return of(false)
    return dependencies.datasetApi.getViewerConfigForCase(caseId, shared).pipe(
        tap(({ name }) =>
            dependencies.store.dispatch(caseActions.loadCase({ caseId, caseName: name, shared }))
        ),
        map(mapApiResponseToViewerState),
        tap(config =>
            dependencies.store.dispatch(viewerActions.configLoaded({ config, queryParams }))
        ),
        map(() => true),
        catchError(err => {
            dependencies.toaster.httpError(err, 'Error loading configuration for dataset.')
            dependencies.router.navigate(['/404'], {
                state: { errorMessage: err.error?.message, errorCode: err.status },
                replaceUrl: true,
            })
            return of(false)
        })
    )
}
